import { useContext } from 'react';
import { isEarlier } from '@/lib/utils/dateUtils';
import InnerDateField from '../DateField/InnerDateField';
import convertToTimestamp from './utils/convertToTimestamp';
import useSavePortfolioItemDate from './utils/useSavePortfolioItemDate';
import PortfolioItemContext from '../../../../PortfolioItemContext';
import moment from 'moment';

const EndDate = () => {
  const { portfolioItem, portfolioItemApiEndpoint } =
    useContext(PortfolioItemContext);

  const savePortfolioItemDate = useSavePortfolioItemDate(
    `${portfolioItemApiEndpoint}/dates/end-date`,
  );

  return (
    <InnerDateField
      initialValue={convertToTimestamp(portfolioItem.endDate)}
      onSave={savePortfolioItemDate}
      shouldDisableDate={
        portfolioItem.startDate === null
          ? undefined
          : date => isEarlier(date, moment(portfolioItem.startDate))
      }
    />
  );
};

export default EndDate;
